export type WorkerRoleStore = {
  isFetchRoles: boolean;
};

export const initialState: WorkerRoleStore = {
  isFetchRoles: false,
};
